"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCheckSignatureStatusDto = instanceOfCheckSignatureStatusDto;
exports.CheckSignatureStatusDtoFromJSON = CheckSignatureStatusDtoFromJSON;
exports.CheckSignatureStatusDtoFromJSONTyped = CheckSignatureStatusDtoFromJSONTyped;
exports.CheckSignatureStatusDtoToJSON = CheckSignatureStatusDtoToJSON;
exports.CheckSignatureStatusDtoToJSONTyped = CheckSignatureStatusDtoToJSONTyped;
var SignatureStatusDto_1 = require("./SignatureStatusDto");
var PropertyDto_1 = require("./PropertyDto");
/**
 * Check if a given object implements the CheckSignatureStatusDto interface.
 */
function instanceOfCheckSignatureStatusDto(value) {
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('property' in value) || value['property'] === undefined)
        return false;
    if (!('salePrice' in value) || value['salePrice'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    return true;
}
function CheckSignatureStatusDtoFromJSON(json) {
    return CheckSignatureStatusDtoFromJSONTyped(json, false);
}
function CheckSignatureStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'signatureStatus': (0, SignatureStatusDto_1.SignatureStatusDtoFromJSON)(json['signatureStatus']),
        'property': (0, PropertyDto_1.PropertyDtoFromJSON)(json['property']),
        'salePrice': json['salePrice'],
        'listingType': json['listingType'],
    };
}
function CheckSignatureStatusDtoToJSON(json) {
    return CheckSignatureStatusDtoToJSONTyped(json, false);
}
function CheckSignatureStatusDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'signatureStatus': (0, SignatureStatusDto_1.SignatureStatusDtoToJSON)(value['signatureStatus']),
        'property': (0, PropertyDto_1.PropertyDtoToJSON)(value['property']),
        'salePrice': value['salePrice'],
        'listingType': value['listingType'],
    };
}
